<template>
	<div class="container index_page">
		<!-- 顶部logo -->
		<div class="toper">
			<i class="logo"></i><span class="version">v2.0</span>
			<div class="admin">
				<img class="avatar" src="../../assets/images/user_icon.png" alt="">{{ authInfo.uname }}
				<el-button type="danger" style="position: relative;top: 5px;margin-left: 15px;" @click="exitLogin">退
					出</el-button>
				<!-- <div class="exit_pop">
					<div class="angle"></div>
					<div class="exit_btn" @click="exitLogin">退  出</div>
				</div> -->
			</div>
		</div>
		<!-- 顶部logo end-->

		<div class="main_box">
			<!-- cate_list -->
			<ul class="cate_list clear_both">
				<li class="item" @click="navigatorToBusinessManage">
					<i class="icon icon_first"></i>
					<p>统一业务管理系统</p>
				</li>
				<li class="item" @click="navigatorToDataGovernance">
					<i class="icon icon_second"></i>
					<p>统一数据监管系统</p>
				</li>
				<li v-if="authInfo.ucategory == 1" class="item" @click="navigatorToBackTools">
					<i class="icon icon_third"></i>
					<p>后台小工具</p>
				</li>
				<li v-if="authInfo.ucategory == 1" class="item" @click="navigatorToOperationManage">
					<i class="icon icon_fourth"></i>
					<p>运营管理系统</p>
				</li>
				<li v-if="authInfo.ucategory == 1 || ['18119972877', '15755405044', '15296769735', '15720581136', '19855606703', '18109680875'].indexOf(authInfo.ucode) != -1"
					class="item" @click="navigatorToApplication">
					<i class="icon icon_fifth"></i>
					<p>科飞云应用程序</p>
				</li>
			</ul>
			<!-- cate_list end-->

			<!-- 底部 -->
			<div class="ft">
				<p>Copyright © 2016 合肥科飞视觉科技有限公司</p>
				<p>科飞视觉 版权所有 皖ICP备13017400号-1</p>
				<!-- <p>{{powerInfo}}</p> -->
			</div>
			<!-- 底部 end -->
		</div>
	</div>
</template>

<script>
	import Login from '../../assets/js/login.js'
	import {
		mapState,
		mapGetters 
	} from "vuex"

	export default {
		computed: {
			...mapState([
				'authInfo'
			]),...mapGetters (['powerInfo'])
		},
		methods: {
			/********************** 点击事件 *****************************/
			// 退出登录
			exitLogin() {
				const that = this;
				this.$confirm(
					'此操作将退出科飞云后台，是否继续?',
					'提示', {
						type: 'warning'
					}
				).then(
					() => {
						Login.exit();
						that.deleteCardEnterprise()
						that.$router.replace({
							path: "/login"
						});
					}
				).catch(
					() => {}
				);
			},
			//删除
			deleteCardEnterprise() {
				localStorage.removeItem('card_enterprise');
			},
			// 跳到统一业务管理系统
			navigatorToBusinessManage() {
			
				window.open(`${ location.origin }/index/business_manage`);
				// this.$router.push({
				// 	path: "/index/business_manage"
				// });
			},
			// 跳到统一数据监管系统
			navigatorToDataGovernance() {
				window.open(`${ location.origin }/index/data_governance`);
				// this.$router.push({
				// 	path: "/index/data_governance"
				// });
			},
			// 跳到后台小工具
			navigatorToBackTools() {
				window.open(`${ location.origin }/index/back_tools/login_type`);
				// this.$router.push({
				// 	path: "/index/back_tools/login_type"
				// });
			},
			// 跳到运营管理系统
			navigatorToOperationManage() {
				window.open(`${ location.origin }/index/operation_manage/user_account_renewal_check`);
				// this.$router.push({
				// 	path: "/index/operation_manage/user_account_renewal_check"
				// });
			},
			// 跳到科飞云应用程序
			navigatorToApplication() {
				window.open(`${ location.origin }/index/application`);
				// this.$router.push({
				// 	path: "/index/operation_manage/user_account_renewal_check"
				// });
			}
		}
	}
</script>

<style scoped>
	.index_page {
		background-image: url(../../assets/images/body_bg.png);
		background-attachment: fixed;
	}

	.index_page .toper {
		display: block;
		position: fixed;
		z-index: 99;
		width: 100%;
		min-width: 1200px;
		height: 62px;
		top: 0;
		left: 0;
		padding: 0 40px;
		border: 1px solid #e4e4e3;
		background-color: #fff;
		box-shadow: 2px 2px 2px rgba(13, 4, 8, 0.05);
	}

	.index_page .toper .logo {
		display: block;
		float: left;
		width: 105px;
		height: 21px;
		margin-top: 20px;
		background-image: url("../../assets/images/kefy.png");
	}

	.index_page .toper .version {
		display: inline-block;
		margin: 25px 0 0 5px;
		font-size: 16px;
		color: #505050;
	}

	.index_page .toper .admin {
		display: block;
		float: right;
		position: relative;
		margin-top: 7px;
		font-size: 20px;
		color: #8a8a8a;
		line-height: 46px;
	}

	.index_page .toper .admin .avatar {
		display: inline-block;
		width: 46px;
		height: 46px;
		margin-right: 30px;
		vertical-align: top;
	}

	.index_page .toper .exit_pop {
		display: none;
		position: absolute;
		width: 140px;
		top: 46px;
		left: 50%;
		margin-left: -70px;
		padding-top: 20px;
	}

	.index_page .toper .exit_pop .angle {
		position: absolute;
		top: 12px;
		left: 50%;
		margin-left: -4px;
		border-left: 6px solid transparent;
		border-right: 6px solid transparent;
		border-bottom: 8px solid #d16d62;
	}

	.index_page .toper .exit_pop .exit_btn {
		display: block;
		width: 100%;
		height: 40px;
		line-height: 40px;
		background-color: #d16d62;
		color: #fff;
		font-size: 18px;
		text-align: center;
		border-radius: 4px;
	}

	/* .index_page .toper .admin:hover .exit_pop{ display: block; } */

	.index_page .main_box {
		position: relative;
		min-height: 100%;
		padding: 62px 0 120px 0;
	}

	.index_page .cate_list {
		display: block;
		width: 1200px;
		margin: 200px auto 0;
	}

	.index_page .cate_list .item {
		display: block;
		float: left;
		width: 240px;
		cursor: pointer;
	}

	.index_page .cate_list .icon {
		display: block;
		width: 154px;
		height: 160px;
		margin: 0 auto;
	}

	.index_page .cate_list .icon_first {
		background-image: url(../../assets/images/index/1.png);
		background-size: 100% 100%;
	}

	.index_page .cate_list .icon_second {
		background-image: url(../../assets/images/index/2.png);
		background-size: 100% 100%;
	}

	.index_page .cate_list .icon_third {
		background-image: url(../../assets/images/index/3.png);
		background-size: 100% 100%;
	}

	.index_page .cate_list .icon_fourth {
		background-image: url(../../assets/images/index/4.png);
		background-size: 100% 100%;
	}

	.index_page .cate_list .icon_fifth {
		background-image: url(../../assets/images/index/5.png);
		background-size: 100% 100%;
	}

	.index_page .cate_list p {
		margin-top: 26px;
		font-size: 20px;
		color: #777;
		text-align: center;
	}

	.index_page .ft {
		position: absolute;
		width: 700px;
		height: 80px;
		bottom: 30px;
		left: 50%;
		margin-left: -350px;
		padding: 24px 0 0 0;
		border-top: 1px solid #e0e0e0;
		font-size: 12px;
		color: #b1b1b1;
		text-align: center;
		line-height: 22px;
	}
</style>